function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("react"), require("styled-components"), require("react-dom")) : "function" == typeof define && define.amd ? define(["react", "styled-components", "react-dom"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["react-airbnb-carousel"] = t(require("react"), require("styled-components"), require("react-dom")) : e["react-airbnb-carousel"] = t(e.react, e["styled-components"], e["react-dom"]);
}(window, function (e, t, n) {
  return function (e) {
    var t = {};

    function n(o) {
      if (t[o]) return t[o].exports;
      var r = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, o) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        n.d(o, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return o;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 63);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    e.exports = n(21)();
  }, function (e, t, n) {
    "use strict";

    var o = n(9);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "checkIndexBounds", {
      enumerable: !0,
      get: function get() {
        return r["default"];
      }
    }), Object.defineProperty(t, "computeIndex", {
      enumerable: !0,
      get: function get() {
        return i["default"];
      }
    }), Object.defineProperty(t, "constant", {
      enumerable: !0,
      get: function get() {
        return a["default"];
      }
    }), Object.defineProperty(t, "getDisplaySameSlide", {
      enumerable: !0,
      get: function get() {
        return u["default"];
      }
    }), Object.defineProperty(t, "mod", {
      enumerable: !0,
      get: function get() {
        return s["default"];
      }
    });
    var r = o(n(35)),
        i = o(n(36)),
        a = o(n(17)),
        u = o(n(37)),
        s = o(n(38));
  }, function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(16);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var r = o(n(23))["default"];
    t["default"] = r;
  }, function (e, t, n) {
    "use strict";

    var o = function o() {};

    e.exports = o;
  }, function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t["default"] = void 0;
    var o = !("undefined" == typeof window || !window.document || !window.document.createElement);
    t["default"] = o, e.exports = t["default"];
  }, function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };
  }, function (e, t) {
    function n() {
      return e.exports = n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      }, n.apply(this, arguments);
    }

    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          o,
          r = {},
          i = Object.keys(e);

      for (o = 0; o < i.length; o++) {
        n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
      }

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) {
          n = a[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
        }
      }

      return r;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    e.exports = function (e, t, o) {
      return t && n(e.prototype, t), o && n(e, o), e;
    };
  }, function (e, t, n) {
    var o = n(40),
        r = n(41);

    e.exports = function (e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? r(e) : t;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    t["default"] = {
      RESISTANCE_COEF: .6,
      UNCERTAINTY_THRESHOLD: 3
    };
  }, function (e, t) {
    function n(t) {
      return "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? e.exports = n = function n(e) {
        return _typeof(e);
      } : e.exports = n = function n(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var o = n(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "autoPlay", {
      enumerable: !0,
      get: function get() {
        return r["default"];
      }
    }), Object.defineProperty(t, "bindKeyboard", {
      enumerable: !0,
      get: function get() {
        return i["default"];
      }
    }), Object.defineProperty(t, "virtualize", {
      enumerable: !0,
      get: function get() {
        return a["default"];
      }
    });
    var r = o(n(39)),
        i = o(n(43)),
        a = o(n(56));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.forceCheck = t.lazyload = void 0;

    var o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        r = n(0),
        i = f(r),
        a = f(n(58)),
        u = f(n(2)),
        s = n(59),
        l = f(n(60)),
        c = f(n(61)),
        d = f(n(62));

    function f(e) {
      return e && e.__esModule ? e : {
        "default": e
      };
    }

    function p(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function h(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != _typeof(t) && "function" != typeof t ? e : t;
    }

    function v(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + _typeof(t));
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var y = 0,
        m = 0,
        g = 0,
        b = 0,
        x = "data-lazyload-listened",
        w = [],
        S = [],
        O = !1;

    try {
      var C = Object.defineProperty({}, "passive", {
        get: function get() {
          O = !0;
        }
      });
      window.addEventListener("test", null, C);
    } catch (e) {}

    var E = !!O && {
      capture: !1,
      passive: !0
    },
        _ = function _(e) {
      var t = a["default"].findDOMNode(e);

      if (t instanceof HTMLElement) {
        var n = (0, l["default"])(t);
        (e.props.overflow && n !== t.ownerDocument && n !== document && n !== document.documentElement ? function (e, t) {
          var n = a["default"].findDOMNode(e),
              o = void 0,
              r = void 0,
              i = void 0,
              u = void 0;

          try {
            var s = t.getBoundingClientRect();
            o = s.top, r = s.left, i = s.height, u = s.width;
          } catch (e) {
            o = y, r = m, i = b, u = g;
          }

          var l = window.innerHeight || document.documentElement.clientHeight,
              c = window.innerWidth || document.documentElement.clientWidth,
              d = Math.max(o, 0),
              f = Math.max(r, 0),
              p = Math.min(l, o + i) - d,
              h = Math.min(c, r + u) - f,
              v = void 0,
              x = void 0,
              w = void 0,
              S = void 0;

          try {
            var O = n.getBoundingClientRect();
            v = O.top, x = O.left, w = O.height, S = O.width;
          } catch (e) {
            v = y, x = m, w = b, S = g;
          }

          var C = v - d,
              E = x - f,
              _ = Array.isArray(e.props.offset) ? e.props.offset : [e.props.offset, e.props.offset];

          return C - _[0] <= p && C + w + _[1] >= 0 && E - _[0] <= h && E + S + _[1] >= 0;
        }(e, n) : function (e) {
          var t = a["default"].findDOMNode(e);
          if (!(t.offsetWidth || t.offsetHeight || t.getClientRects().length)) return !1;
          var n = void 0,
              o = void 0;

          try {
            var r = t.getBoundingClientRect();
            n = r.top, o = r.height;
          } catch (e) {
            n = y, o = b;
          }

          var i = window.innerHeight || document.documentElement.clientHeight,
              u = Array.isArray(e.props.offset) ? e.props.offset : [e.props.offset, e.props.offset];
          return n - u[0] <= i && n + o + u[1] >= 0;
        }(e)) ? e.visible || (e.props.once && S.push(e), e.visible = !0, e.forceUpdate()) : e.props.once && e.visible || (e.visible = !1, e.props.unmountIfInvisible && e.forceUpdate());
      }
    },
        j = function j() {
      for (var e = 0; e < w.length; ++e) {
        var t = w[e];

        _(t);
      }

      S.forEach(function (e) {
        var t = w.indexOf(e);
        -1 !== t && w.splice(t, 1);
      }), S = [];
    },
        T = void 0,
        I = null,
        M = function (e) {
      function t(e) {
        p(this, t);
        var n = h(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        return n.visible = !1, n;
      }

      return v(t, e), o(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = window,
              t = this.props.scrollContainer;
          t && "string" == typeof t && (e = e.document.querySelector(t));
          var n = void 0 !== this.props.debounce && "throttle" === T || "debounce" === T && void 0 === this.props.debounce;

          if (n && ((0, s.off)(e, "scroll", I, E), (0, s.off)(window, "resize", I, E), I = null), I || (void 0 !== this.props.debounce ? (I = (0, c["default"])(j, "number" == typeof this.props.debounce ? this.props.debounce : 300), T = "debounce") : void 0 !== this.props.throttle ? (I = (0, d["default"])(j, "number" == typeof this.props.throttle ? this.props.throttle : 300), T = "throttle") : I = j), this.props.overflow) {
            var o = (0, l["default"])(a["default"].findDOMNode(this));

            if (o && "function" == typeof o.getAttribute) {
              var r = +o.getAttribute(x) + 1;
              1 === r && o.addEventListener("scroll", I, E), o.setAttribute(x, r);
            }
          } else if (0 === w.length || n) {
            var i = this.props,
                u = i.scroll,
                f = i.resize;
            u && (0, s.on)(e, "scroll", I, E), f && (0, s.on)(window, "resize", I, E);
          }

          w.push(this), _(this);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function value() {
          return this.visible;
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          if (this.props.overflow) {
            var e = (0, l["default"])(a["default"].findDOMNode(this));

            if (e && "function" == typeof e.getAttribute) {
              var t = +e.getAttribute(x) - 1;
              0 === t ? (e.removeEventListener("scroll", I, E), e.removeAttribute(x)) : e.setAttribute(x, t);
            }
          }

          var n = w.indexOf(this);
          -1 !== n && w.splice(n, 1), 0 === w.length && "undefined" != typeof window && ((0, s.off)(window, "resize", I, E), (0, s.off)(window, "scroll", I, E));
        }
      }, {
        key: "render",
        value: function value() {
          return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : i["default"].createElement("div", {
            style: {
              height: this.props.height
            },
            className: "lazyload-placeholder"
          });
        }
      }]), t;
    }(r.Component);

    M.propTypes = {
      once: u["default"].bool,
      height: u["default"].oneOfType([u["default"].number, u["default"].string]),
      offset: u["default"].oneOfType([u["default"].number, u["default"].arrayOf(u["default"].number)]),
      overflow: u["default"].bool,
      resize: u["default"].bool,
      scroll: u["default"].bool,
      children: u["default"].node,
      throttle: u["default"].oneOfType([u["default"].number, u["default"].bool]),
      debounce: u["default"].oneOfType([u["default"].number, u["default"].bool]),
      placeholder: u["default"].node,
      scrollContainer: u["default"].oneOfType([u["default"].string, u["default"].object]),
      unmountIfInvisible: u["default"].bool
    }, M.defaultProps = {
      once: !1,
      offset: 0,
      overflow: !1,
      resize: !1,
      scroll: !0,
      unmountIfInvisible: !1
    };

    var k = function k(e) {
      return e.displayName || e.name || "Component";
    };

    t.lazyload = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return function (t) {
        return function (n) {
          function r() {
            p(this, r);
            var e = h(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this));
            return e.displayName = "LazyLoad" + k(t), e;
          }

          return v(r, n), o(r, [{
            key: "render",
            value: function value() {
              return i["default"].createElement(M, e, i["default"].createElement(t, this.props));
            }
          }]), r;
        }(r.Component);
      };
    }, t["default"] = M, t.forceCheck = j;
  }, function (e, t, n) {
    "use strict";

    var o = n(22);

    function r() {}

    function i() {}

    i.resetWarningCache = r, e.exports = function () {
      function e(e, t, n, r, i, a) {
        if (a !== o) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: r
      };
      return n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var o = n(16);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.getDomTreeShapes = C, t.findNativeHandler = _, t["default"] = void 0;
    var r = o(n(24)),
        i = o(n(25)),
        a = o(n(26)),
        u = o(n(27)),
        s = o(n(28)),
        l = o(n(31)),
        c = o(n(0)),
        d = o(n(2)),
        f = (o(n(6)), o(n(32))),
        p = o(n(33)),
        h = o(n(34)),
        v = n(3);

    function y(e, t, n, o) {
      return (0, p["default"])(e, t, n, o), {
        remove: function remove() {
          (0, h["default"])(e, t, n, o);
        }
      };
    }

    var m = !1;
    var g = {
      direction: "ltr",
      display: "flex",
      willChange: "transform"
    },
        b = {
      width: "100%",
      WebkitFlexShrink: 0,
      flexShrink: 0,
      overflow: "auto"
    },
        x = {
      root: {
        x: {
          overflowX: "hidden"
        },
        "x-reverse": {
          overflowX: "hidden"
        },
        y: {
          overflowY: "hidden"
        },
        "y-reverse": {
          overflowY: "hidden"
        }
      },
      flexDirection: {
        x: "row",
        "x-reverse": "row-reverse",
        y: "column",
        "y-reverse": "column-reverse"
      },
      transform: {
        x: function x(e) {
          return "translate(".concat(-e, "%, 0)");
        },
        "x-reverse": function xReverse(e) {
          return "translate(".concat(e, "%, 0)");
        },
        y: function y(e) {
          return "translate(0, ".concat(-e, "%)");
        },
        "y-reverse": function yReverse(e) {
          return "translate(0, ".concat(e, "%)");
        }
      },
      length: {
        x: "width",
        "x-reverse": "width",
        y: "height",
        "y-reverse": "height"
      },
      rotationMatrix: {
        x: {
          x: [1, 0],
          y: [0, 1]
        },
        "x-reverse": {
          x: [-1, 0],
          y: [0, 1]
        },
        y: {
          x: [0, 1],
          y: [1, 0]
        },
        "y-reverse": {
          x: [0, -1],
          y: [1, 0]
        }
      },
      scrollPosition: {
        x: "scrollLeft",
        "x-reverse": "scrollLeft",
        y: "scrollTop",
        "y-reverse": "scrollTop"
      },
      scrollLength: {
        x: "scrollWidth",
        "x-reverse": "scrollWidth",
        y: "scrollHeight",
        "y-reverse": "scrollHeight"
      },
      clientLength: {
        x: "clientWidth",
        "x-reverse": "clientWidth",
        y: "clientHeight",
        "y-reverse": "clientHeight"
      }
    };

    function w(e, t) {
      var n = t.duration,
          o = t.easeFunction,
          r = t.delay;
      return "".concat(e, " ").concat(n, " ").concat(o, " ").concat(r);
    }

    function S(e, t) {
      var n = x.rotationMatrix[t];
      return {
        pageX: n.x[0] * e.pageX + n.x[1] * e.pageY,
        pageY: n.y[0] * e.pageX + n.y[1] * e.pageY
      };
    }

    function O(e) {
      return e.touches = [{
        pageX: e.pageX,
        pageY: e.pageY
      }], e;
    }

    function C(e, t) {
      for (var n = []; e && e !== t && !e.hasAttribute("data-swipeable");) {
        var o = window.getComputedStyle(e);
        "absolute" === o.getPropertyValue("position") || "hidden" === o.getPropertyValue("overflow-x") ? n = [] : (e.clientWidth > 0 && e.scrollWidth > e.clientWidth || e.clientHeight > 0 && e.scrollHeight > e.clientHeight) && n.push({
          element: e,
          scrollWidth: e.scrollWidth,
          scrollHeight: e.scrollHeight,
          clientWidth: e.clientWidth,
          clientHeight: e.clientHeight,
          scrollLeft: e.scrollLeft,
          scrollTop: e.scrollTop
        }), e = e.parentNode;
      }

      return n;
    }

    var E = null;

    function _(e) {
      var t = e.domTreeShapes,
          n = e.pageX,
          o = e.startX,
          r = e.axis;
      return t.some(function (e) {
        var t = n >= o;
        "x" !== r && "y" !== r || (t = !t);
        var i = e[x.scrollPosition[r]],
            a = i > 0,
            u = i + e[x.clientLength[r]] < e[x.scrollLength[r]];
        return !!(t && u || !t && a) && (E = e.element, !0);
      });
    }

    var j = function (e) {
      function t(e, n) {
        var o;
        return (0, a["default"])(this, t), (o = (0, s["default"])(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n))).setRootNode = function (e) {
          o.rootNode = e;
        }, o.setContainerNode = function (e) {
          o.containerNode = e;
        }, o.setActiveSlide = function (e) {
          o.activeSlide = e, o.updateHeight();
        }, o.rootNode = null, o.containerNode = null, o.ignoreNextScrollEvents = !1, o.viewLength = 0, o.startX = 0, o.lastX = 0, o.vx = 0, o.startY = 0, o.isSwiping = void 0, o.started = !1, o.startIndex = 0, o.transitionListener = null, o.touchMoveListener = null, o.activeSlide = null, o.indexCurrent = null, o.handleSwipeStart = function (e) {
          var t = o.props.axis,
              n = S(e.touches[0], t);
          o.viewLength = o.rootNode.getBoundingClientRect()[x.length[t]], o.startX = n.pageX, o.lastX = n.pageX, o.vx = 0, o.startY = n.pageY, o.isSwiping = void 0, o.started = !0;
          var r = window.getComputedStyle(o.containerNode),
              i = r.getPropertyValue("-webkit-transform") || r.getPropertyValue("transform");

          if (i && "none" !== i) {
            var a = i.split("(")[1].split(")")[0].split(","),
                u = window.getComputedStyle(o.rootNode),
                s = S({
              pageX: parseInt(a[4], 10),
              pageY: parseInt(a[5], 10)
            }, t);
            o.startIndex = -s.pageX / (o.viewLength - parseInt(u.paddingLeft, 10) - parseInt(u.paddingRight, 10)) || 0;
          }
        }, o.handleSwipeMove = function (e) {
          if (o.started) {
            if (null === E || E === o.rootNode) {
              var t = o.props,
                  n = t.axis,
                  r = t.children,
                  i = t.ignoreNativeScroll,
                  a = t.onSwitching,
                  u = t.resistance,
                  s = S(e.touches[0], n);

              if (void 0 === o.isSwiping) {
                var l = Math.abs(s.pageX - o.startX),
                    d = Math.abs(s.pageY - o.startY),
                    f = l > d && l > v.constant.UNCERTAINTY_THRESHOLD;
                if (!u && ("y" === n || "y-reverse" === n) && (0 === o.indexCurrent && o.startX < s.pageX || o.indexCurrent === c["default"].Children.count(o.props.children) - 1 && o.startX > s.pageX)) return void (o.isSwiping = !1);
                if (l > d && e.preventDefault(), !0 === f || d > v.constant.UNCERTAINTY_THRESHOLD) return o.isSwiping = f, void (o.startX = s.pageX);
              }

              if (!0 === o.isSwiping) {
                e.preventDefault(), o.vx = .5 * o.vx + .5 * (s.pageX - o.lastX), o.lastX = s.pageX;
                var p = (0, v.computeIndex)({
                  children: r,
                  resistance: u,
                  pageX: s.pageX,
                  startIndex: o.startIndex,
                  startX: o.startX,
                  viewLength: o.viewLength
                }),
                    h = p.index,
                    y = p.startX;
                if (null === E && !i) if (_({
                  domTreeShapes: C(e.target, o.rootNode),
                  startX: o.startX,
                  pageX: s.pageX,
                  axis: n
                })) return;
                y ? o.startX = y : null === E && (E = o.rootNode), o.setIndexCurrent(h);

                var m = function m() {
                  a && a(h, "move");
                };

                !o.state.displaySameSlide && o.state.isDragging || o.setState({
                  displaySameSlide: !1,
                  isDragging: !0
                }, m), m();
              }
            }
          } else o.handleTouchStart(e);
        }, o.handleSwipeEnd = function () {
          if (E = null, o.started && (o.started = !1, !0 === o.isSwiping)) {
            var e,
                t = o.state.indexLatest,
                n = o.indexCurrent,
                r = t - n;
            e = Math.abs(o.vx) > o.props.threshold ? o.vx > 0 ? Math.floor(n) : Math.ceil(n) : Math.abs(r) > o.props.hysteresis ? r > 0 ? Math.floor(n) : Math.ceil(n) : t;
            var i = c["default"].Children.count(o.props.children) - 1;
            e < 0 ? e = 0 : e > i && (e = i), o.setIndexCurrent(e), o.setState({
              indexLatest: e,
              isDragging: !1
            }, function () {
              o.props.onSwitching && o.props.onSwitching(e, "end"), o.props.onChangeIndex && e !== t && o.props.onChangeIndex(e, t, {
                reason: "swipe"
              }), n === t && o.handleTransitionEnd();
            });
          }
        }, o.handleTouchStart = function (e) {
          o.props.onTouchStart && o.props.onTouchStart(e), o.handleSwipeStart(e);
        }, o.handleTouchEnd = function (e) {
          o.props.onTouchEnd && o.props.onTouchEnd(e), o.handleSwipeEnd(e);
        }, o.handleMouseDown = function (e) {
          o.props.onMouseDown && o.props.onMouseDown(e), e.persist(), o.handleSwipeStart(O(e));
        }, o.handleMouseUp = function (e) {
          o.props.onMouseUp && o.props.onMouseUp(e), o.handleSwipeEnd(O(e));
        }, o.handleMouseLeave = function (e) {
          o.props.onMouseLeave && o.props.onMouseLeave(e), o.started && o.handleSwipeEnd(O(e));
        }, o.handleMouseMove = function (e) {
          o.props.onMouseMove && o.props.onMouseMove(e), o.started && o.handleSwipeMove(O(e));
        }, o.handleScroll = function (e) {
          if (o.props.onScroll && o.props.onScroll(e), e.target === o.rootNode) if (o.ignoreNextScrollEvents) o.ignoreNextScrollEvents = !1;else {
            var t = o.state.indexLatest,
                n = Math.ceil(e.target.scrollLeft / e.target.clientWidth) + t;
            o.ignoreNextScrollEvents = !0, e.target.scrollLeft = 0, o.props.onChangeIndex && n !== t && o.props.onChangeIndex(n, t, {
              reason: "focus"
            });
          }
        }, o.updateHeight = function () {
          if (null !== o.activeSlide) {
            var e = o.activeSlide.children[0];
            void 0 !== e && void 0 !== e.offsetHeight && o.state.heightLatest !== e.offsetHeight && o.setState({
              heightLatest: e.offsetHeight
            });
          }
        }, o.state = {
          indexLatest: o.props.index,
          isDragging: !1,
          isFirstRender: !0,
          heightLatest: 0,
          displaySameSlide: !0
        }, o.setIndexCurrent(o.props.index), o;
      }

      return (0, l["default"])(t, e), (0, u["default"])(t, [{
        key: "getChildContext",
        value: function value() {
          var e = this;
          return {
            swipeableViews: {
              slideUpdateHeight: function slideUpdateHeight() {
                e.updateHeight();
              }
            }
          };
        }
      }, {
        key: "componentDidMount",
        value: function value() {
          var e = this;
          this.transitionListener = y(this.containerNode, f["default"].end, function (t) {
            t.target === e.containerNode && e.handleTransitionEnd();
          }), this.touchMoveListener = y(this.rootNode, "touchmove", function (t) {
            e.props.disabled || e.handleSwipeMove(t);
          }, {
            passive: !1
          }), this.setState({
            isFirstRender: !1
          }), function () {
            if (!m) {
              var e = document.createElement("style");
              e.innerHTML = "\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ", document.body && document.body.appendChild(e), m = !0;
            }
          }(), this.props.action && this.props.action({
            updateHeight: this.updateHeight
          });
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = e.index;
          "number" == typeof t && t !== this.props.index && (this.setIndexCurrent(t), this.setState({
            displaySameSlide: (0, v.getDisplaySameSlide)(this.props, e),
            indexLatest: t
          }));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.transitionListener.remove(), this.touchMoveListener.remove();
        }
      }, {
        key: "setIndexCurrent",
        value: function value(e) {
          if (this.props.animateTransitions || this.indexCurrent === e || this.handleTransitionEnd(), this.indexCurrent = e, this.containerNode) {
            var t = this.props.axis,
                n = x.transform[t](100 * e);
            this.containerNode.style.WebkitTransform = n, this.containerNode.style.transform = n;
          }
        }
      }, {
        key: "handleTransitionEnd",
        value: function value() {
          this.props.onTransitionEnd && (this.state.displaySameSlide || this.state.isDragging || this.props.onTransitionEnd());
        }
      }, {
        key: "render",
        value: function value() {
          var e,
              t,
              n = this,
              o = this.props,
              a = (o.action, o.animateHeight),
              u = o.animateTransitions,
              s = o.axis,
              l = o.children,
              d = o.containerStyle,
              f = o.disabled,
              p = o.disableLazyLoading,
              h = o.enableMouseEvents,
              v = (o.hysteresis, o.ignoreNativeScroll, o.index, o.onChangeIndex, o.onSwitching, o.onTransitionEnd, o.resistance, o.slideStyle),
              y = o.slideClassName,
              m = o.springConfig,
              S = o.style,
              O = (o.threshold, (0, i["default"])(o, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"])),
              C = this.state,
              E = C.displaySameSlide,
              _ = C.heightLatest,
              j = C.isDragging,
              T = C.isFirstRender,
              I = C.indexLatest,
              M = f ? {} : {
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd
          },
              k = !f && h ? {
            onMouseDown: this.handleMouseDown,
            onMouseUp: this.handleMouseUp,
            onMouseLeave: this.handleMouseLeave,
            onMouseMove: this.handleMouseMove
          } : {},
              P = (0, r["default"])({}, b, v);
          if (j || !u || E) e = "all 0s ease 0s", t = "all 0s ease 0s";else if (e = w("transform", m), t = w("-webkit-transform", m), 0 !== _) {
            var L = ", ".concat(w("height", m));
            e += L, t += L;
          }
          var N = {
            height: null,
            WebkitFlexDirection: x.flexDirection[s],
            flexDirection: x.flexDirection[s],
            WebkitTransition: t,
            transition: e
          };

          if (p || !T) {
            var D = x.transform[s](100 * this.indexCurrent);
            N.WebkitTransform = D, N.transform = D;
          }

          return a && (N.height = _), c["default"].createElement("div", (0, r["default"])({
            ref: this.setRootNode,
            style: (0, r["default"])({}, x.root[s], S)
          }, O, M, k, {
            onScroll: this.handleScroll
          }), c["default"].createElement("div", {
            ref: this.setContainerNode,
            style: (0, r["default"])({}, N, g, d),
            className: "react-swipeable-view-container"
          }, c["default"].Children.map(l, function (e, t) {
            if (!p && T && t !== I) return null;
            var o,
                r = !0;
            return t === I && (r = !1, a && (o = n.setActiveSlide, P.overflowY = "hidden")), c["default"].createElement("div", {
              ref: o,
              style: P,
              className: y,
              "aria-hidden": r,
              "data-swipeable": "true"
            }, e);
          })));
        }
      }]), t;
    }(c["default"].Component);

    j.displayName = "ReactSwipableView", j.propTypes = {}, j.defaultProps = {
      animateHeight: !1,
      animateTransitions: !0,
      axis: "x",
      disabled: !1,
      disableLazyLoading: !1,
      enableMouseEvents: !1,
      hysteresis: .6,
      ignoreNativeScroll: !1,
      index: 0,
      threshold: 5,
      springConfig: {
        duration: "0.35s",
        easeFunction: "cubic-bezier(0.15, 0.3, 0.25, 1)",
        delay: "0s"
      },
      resistance: !1
    }, j.childContextTypes = {
      swipeableViews: d["default"].shape({
        slideUpdateHeight: d["default"].func
      })
    };
    var T = j;
    t["default"] = T;
  }, function (e, t) {
    function n() {
      return e.exports = n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      }, n.apply(this, arguments);
    }

    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          o,
          r = {},
          i = Object.keys(e);

      for (o = 0; o < i.length; o++) {
        n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
      }

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) {
          n = a[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
        }
      }

      return r;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    e.exports = function (e, t, o) {
      return t && n(e.prototype, t), o && n(e, o), e;
    };
  }, function (e, t, n) {
    var o = n(29),
        r = n(30);

    e.exports = function (e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? r(e) : t;
    };
  }, function (e, t) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function o(t) {
      return "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? e.exports = o = function o(e) {
        return n(e);
      } : e.exports = o = function o(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : n(e);
      }, o(t);
    }

    e.exports = o;
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(7);
    t.__esModule = !0, t["default"] = t.animationEnd = t.animationDelay = t.animationTiming = t.animationDuration = t.animationName = t.transitionEnd = t.transitionDuration = t.transitionDelay = t.transitionTiming = t.transitionProperty = t.transform = void 0;
    var r,
        i,
        a,
        u,
        s,
        l,
        c,
        d,
        f,
        p,
        h,
        v = o(n(8)),
        y = "transform";

    if (t.transform = y, t.animationEnd = a, t.transitionEnd = i, t.transitionDelay = c, t.transitionTiming = l, t.transitionDuration = s, t.transitionProperty = u, t.animationDelay = h, t.animationTiming = p, t.animationDuration = f, t.animationName = d, v["default"]) {
      var m = function () {
        for (var e, t, n = document.createElement("div").style, o = {
          O: function O(e) {
            return "o" + e.toLowerCase();
          },
          Moz: function Moz(e) {
            return e.toLowerCase();
          },
          Webkit: function Webkit(e) {
            return "webkit" + e;
          },
          ms: function ms(e) {
            return "MS" + e;
          }
        }, r = Object.keys(o), i = "", a = 0; a < r.length; a++) {
          var u = r[a];

          if (u + "TransitionProperty" in n) {
            i = "-" + u.toLowerCase(), e = o[u]("TransitionEnd"), t = o[u]("AnimationEnd");
            break;
          }
        }

        !e && "transitionProperty" in n && (e = "transitionend");
        !t && "animationName" in n && (t = "animationend");
        return n = null, {
          animationEnd: t,
          transitionEnd: e,
          prefix: i
        };
      }();

      r = m.prefix, t.transitionEnd = i = m.transitionEnd, t.animationEnd = a = m.animationEnd, t.transform = y = r + "-" + y, t.transitionProperty = u = r + "-transition-property", t.transitionDuration = s = r + "-transition-duration", t.transitionDelay = c = r + "-transition-delay", t.transitionTiming = l = r + "-transition-timing-function", t.animationName = d = r + "-animation-name", t.animationDuration = f = r + "-animation-duration", t.animationTiming = p = r + "-animation-delay", t.animationDelay = h = r + "-animation-timing-function";
    }

    var g = {
      transform: y,
      end: i,
      property: u,
      timing: l,
      delay: c,
      duration: s
    };
    t["default"] = g;
  }, function (e, t, n) {
    "use strict";

    var o = n(7);
    t.__esModule = !0, t["default"] = void 0;

    var r = function r() {};

    o(n(8))["default"] && (r = document.addEventListener ? function (e, t, n, o) {
      return e.addEventListener(t, n, o || !1);
    } : document.attachEvent ? function (e, t, n) {
      return e.attachEvent("on" + t, function (t) {
        (t = t || window.event).target = t.target || t.srcElement, t.currentTarget = e, n.call(e, t);
      });
    } : void 0);
    var i = r;
    t["default"] = i, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    var o = n(7);
    t.__esModule = !0, t["default"] = void 0;

    var r = function r() {};

    o(n(8))["default"] && (r = document.addEventListener ? function (e, t, n, o) {
      return e.removeEventListener(t, n, o || !1);
    } : document.attachEvent ? function (e, t, n) {
      return e.detachEvent("on" + t, n);
    } : void 0);
    var i = r;
    t["default"] = i, e.exports = t["default"];
  }, function (e, t, n) {
    "use strict";

    var o = n(9);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;
    var r = o(n(0)),
        i = (o(n(6)), function (e) {
      e.index;
      var t = e.children;
      r["default"].Children.count(t);
    });
    t["default"] = i;
  }, function (e, t, n) {
    "use strict";

    var o = n(9);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e) {
      var t,
          n = e.children,
          o = e.startIndex,
          a = e.startX,
          u = e.pageX,
          s = e.viewLength,
          l = e.resistance,
          c = r["default"].Children.count(n) - 1,
          d = o + (a - u) / s;
      l ? d < 0 ? d = Math.exp(d * i["default"].RESISTANCE_COEF) - 1 : d > c && (d = c + 1 - Math.exp((c - d) * i["default"].RESISTANCE_COEF)) : d < 0 ? t = ((d = 0) - o) * s + u : d > c && (t = ((d = c) - o) * s + u);
      return {
        index: d,
        startX: t
      };
    };
    var r = o(n(0)),
        i = o(n(17));
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;

    var o = function o(e, t) {
      var n = !1;

      if (e.children.length && t.children.length) {
        var o = e.children[e.index],
            r = o ? o.key : "empty";

        if (null !== r) {
          var i = t.children[t.index];
          r === (i ? i.key : "empty") && (n = !0);
        }
      }

      return n;
    };

    t["default"] = o;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = void 0;

    var o = function o(e, t) {
      var n = e % t;
      return n < 0 ? n + t : n;
    };

    t["default"] = o;
  }, function (e, t, n) {
    "use strict";

    var o = n(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e) {
      var t = function (t) {
        function n(e, t) {
          var o;
          return (0, a["default"])(this, n), (o = (0, s["default"])(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t))).state = {}, o.timer = null, o.handleInterval = function () {
            var e = o.props,
                t = e.children,
                n = e.direction,
                r = e.onChangeIndex,
                i = e.slideCount,
                a = o.state.index,
                u = a;
            "incremental" === n ? u += 1 : u -= 1, (i || t) && (u = (0, f.mod)(u, i || c["default"].Children.count(t))), void 0 === o.props.index && o.setState({
              index: u
            }), r && r(u, a);
          }, o.handleChangeIndex = function (e, t) {
            void 0 === o.props.index && o.setState({
              index: e
            }), o.props.onChangeIndex && o.props.onChangeIndex(e, t);
          }, o.handleSwitching = function (e, t) {
            o.timer ? (clearInterval(o.timer), o.timer = null) : "end" === t && o.startInterval(), o.props.onSwitching && o.props.onSwitching(e, t);
          }, o.state.index = o.props.index || 0, o;
        }

        return (0, l["default"])(n, t), (0, u["default"])(n, [{
          key: "componentDidMount",
          value: function value() {
            this.startInterval();
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            var t = e.index;
            "number" == typeof t && t !== this.props.index && this.setState({
              index: t
            });
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e) {
            !(0, d["default"])({
              index: e.index,
              interval: e.interval,
              autoplay: e.autoplay
            }, {
              index: this.props.index,
              interval: this.props.interval,
              autoplay: this.props.autoplay
            }) && this.startInterval();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            clearInterval(this.timer);
          }
        }, {
          key: "startInterval",
          value: function value() {
            var e = this.props,
                t = e.autoplay,
                n = e.interval;
            clearInterval(this.timer), t && (this.timer = setInterval(this.handleInterval, n));
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
                n = t.autoplay,
                o = (t.direction, t.interval, t.index, t.onChangeIndex, (0, i["default"])(t, ["autoplay", "direction", "interval", "index", "onChangeIndex"])),
                a = this.state.index;
            return n ? c["default"].createElement(e, (0, r["default"])({
              index: a,
              onChangeIndex: this.handleChangeIndex,
              onSwitching: this.handleSwitching
            }, o)) : c["default"].createElement(e, (0, r["default"])({
              index: a
            }, o));
          }
        }]), n;
      }(c["default"].Component);

      return t.defaultProps = {
        autoplay: !0,
        direction: "incremental",
        interval: 3e3
      }, t.propTypes = {}, t;
    };
    var r = o(n(10)),
        i = o(n(11)),
        a = o(n(12)),
        u = o(n(13)),
        s = o(n(14)),
        l = o(n(15)),
        c = o(n(0)),
        d = (o(n(2)), o(n(42))),
        f = n(3);
  }, function (e, t) {
    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function o(t) {
      return "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? e.exports = o = function o(e) {
        return n(e);
      } : e.exports = o = function o(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : n(e);
      }, o(t);
    }

    e.exports = o;
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t, n) {
    "use strict";

    var o = Object.prototype.hasOwnProperty;

    function r(e, t) {
      return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
    }

    e.exports = function (e, t) {
      if (r(e, t)) return !0;
      if ("object" != _typeof(e) || null === e || "object" != _typeof(t) || null === t) return !1;
      var n = Object.keys(e),
          i = Object.keys(t);
      if (n.length !== i.length) return !1;

      for (var a = 0; a < n.length; a++) {
        if (!o.call(t, n[a]) || !r(e[n[a]], t[n[a]])) return !1;
      }

      return !0;
    };
  }, function (e, t, n) {
    "use strict";

    var o = n(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e) {
      var t = function (t) {
        function n() {
          var e, t, o;
          (0, a["default"])(this, n);

          for (var r = arguments.length, i = new Array(r), u = 0; u < r; u++) {
            i[u] = arguments[u];
          }

          return (0, s["default"])(o, (t = o = (0, s["default"])(this, (e = n.__proto__ || Object.getPrototypeOf(n)).call.apply(e, [this].concat(i))), o.state = {}, o.handleKeyDown = function (e) {
            var t,
                n = o.props,
                r = n.axis,
                i = void 0 === r ? "x" : r,
                a = n.children,
                u = n.onChangeIndex,
                s = n.slideCount;

            switch ((0, d["default"])(e)) {
              case "page down":
              case "down":
                "y" === i ? t = "decrease" : "y-reverse" === i && (t = "increase");
                break;

              case "left":
                "x" === i ? t = "decrease" : "x-reverse" === i && (t = "increase");
                break;

              case "page up":
              case "up":
                "y" === i ? t = "increase" : "y-reverse" === i && (t = "decrease");
                break;

              case "right":
                "x" === i ? t = "increase" : "x-reverse" === i && (t = "decrease");
            }

            if (t) {
              var l = o.state.index,
                  f = l;
              "increase" === t ? f += 1 : f -= 1, (s || a) && (f = (0, p.mod)(f, s || c["default"].Children.count(a))), void 0 === o.props.index && o.setState({
                index: f
              }), u && u(f, l);
            }
          }, o.handleChangeIndex = function (e, t) {
            void 0 === o.props.index && o.setState({
              index: e
            }), o.props.onChangeIndex && o.props.onChangeIndex(e, t);
          }, t));
        }

        return (0, l["default"])(n, t), (0, u["default"])(n, [{
          key: "componentWillMount",
          value: function value() {
            this.setState({
              index: this.props.index || 0
            });
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            var t = e.index;
            "number" == typeof t && t !== this.props.index && this.setState({
              index: t
            });
          }
        }, {
          key: "render",
          value: function value() {
            var t = this.props,
                n = (t.index, t.onChangeIndex, (0, i["default"])(t, ["index", "onChangeIndex"])),
                o = this.state.index;
            return c["default"].createElement(f["default"], {
              target: "window",
              onKeyDown: this.handleKeyDown
            }, c["default"].createElement(e, (0, r["default"])({
              index: o,
              onChangeIndex: this.handleChangeIndex
            }, n)));
          }
        }]), n;
      }(c["default"].Component);

      return t.propTypes = {}, t;
    };
    var r = o(n(10)),
        i = o(n(11)),
        a = o(n(12)),
        u = o(n(13)),
        s = o(n(14)),
        l = o(n(15)),
        c = o(n(0)),
        d = (o(n(2)), o(n(44))),
        f = o(n(45)),
        p = n(3);
  }, function (e, t) {
    function n(e) {
      if (e && "object" == _typeof(e)) {
        var t = e.which || e.keyCode || e.charCode;
        t && (e = t);
      }

      if ("number" == typeof e) return a[e];
      var n,
          i = String(e);
      return (n = o[i.toLowerCase()]) ? n : (n = r[i.toLowerCase()]) || (1 === i.length ? i.charCodeAt(0) : void 0);
    }

    n.isEventKey = function (e, t) {
      if (e && "object" == _typeof(e)) {
        var n = e.which || e.keyCode || e.charCode;
        if (null == n) return !1;

        if ("string" == typeof t) {
          var i;
          if (i = o[t.toLowerCase()]) return i === n;
          if (i = r[t.toLowerCase()]) return i === n;
        } else if ("number" == typeof t) return t === n;

        return !1;
      }
    };

    var o = (t = e.exports = n).code = t.codes = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      ctrl: 17,
      alt: 18,
      "pause/break": 19,
      "caps lock": 20,
      esc: 27,
      space: 32,
      "page up": 33,
      "page down": 34,
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40,
      insert: 45,
      "delete": 46,
      command: 91,
      "left command": 91,
      "right command": 93,
      "numpad *": 106,
      "numpad +": 107,
      "numpad -": 109,
      "numpad .": 110,
      "numpad /": 111,
      "num lock": 144,
      "scroll lock": 145,
      "my computer": 182,
      "my calculator": 183,
      ";": 186,
      "=": 187,
      ",": 188,
      "-": 189,
      ".": 190,
      "/": 191,
      "`": 192,
      "[": 219,
      "\\": 220,
      "]": 221,
      "'": 222
    },
        r = t.aliases = {
      windows: 91,
      "⇧": 16,
      "⌥": 18,
      "⌃": 17,
      "⌘": 91,
      ctl: 17,
      control: 17,
      option: 18,
      pause: 19,
      "break": 19,
      caps: 20,
      "return": 13,
      escape: 27,
      spc: 32,
      spacebar: 32,
      pgup: 33,
      pgdn: 34,
      ins: 45,
      del: 46,
      cmd: 91
    };
    /*!
     * Programatically add the following
     */

    for (i = 97; i < 123; i++) {
      o[String.fromCharCode(i)] = i - 32;
    }

    for (var i = 48; i < 58; i++) {
      o[i - 48] = i;
    }

    for (i = 1; i < 13; i++) {
      o["f" + i] = i + 111;
    }

    for (i = 0; i < 10; i++) {
      o["numpad " + i] = i + 96;
    }

    var a = t.names = t.title = {};

    for (i in o) {
      a[o[i]] = i;
    }

    for (var u in r) {
      o[u] = r[u];
    }
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && "object" == _typeof(e) && "default" in e ? e["default"] : e;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = o(n(46)),
        i = o(n(47)),
        a = o(n(48)),
        u = o(n(50)),
        s = o(n(51)),
        l = o(n(18)),
        c = o(n(53)),
        d = o(n(55)),
        f = o(n(0));
    o(n(2)), o(n(6));
    var p,
        h = (p = null, function () {
      if (null !== p) return p;
      var e,
          t,
          n,
          o = !1;

      try {
        window.addEventListener("test", null, (e = {}, t = "passive", n = {
          get: function get() {
            o = !0;
          }
        }, Object.defineProperty(e, t, n)));
      } catch (e) {}

      return p = o, o;
    }()),
        v = {
      capture: !1,
      passive: !1
    };

    function y(e) {
      return d({}, v, e);
    }

    function m(e, t, n) {
      var o = [e, t];
      return o.push(h ? n : n.capture), o;
    }

    function g(e, t, n, o) {
      e.addEventListener.apply(e, m(t, n, o));
    }

    function b(e, t, n, o) {
      e.removeEventListener.apply(e, m(t, n, o));
    }

    function x(e, t) {
      e.children, e.target;
      var n = c(e, ["children", "target"]);
      Object.keys(n).forEach(function (e) {
        if ("on" === e.substring(0, 2)) {
          var o = n[e],
              r = l(o),
              i = "object" === r;

          if (i || "function" === r) {
            var a = "capture" === e.substr(-7).toLowerCase(),
                u = e.substring(2).toLowerCase();
            u = a ? u.substring(0, u.length - 7) : u, i ? t(u, o.handler, o.options) : t(u, o, y({
              capture: a
            }));
          }
        }
      });
    }

    var w = function (e) {
      function t() {
        return r(this, t), a(this, u(t).apply(this, arguments));
      }

      return s(t, e), i(t, [{
        key: "componentDidMount",
        value: function value() {
          this.applyListeners(g);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          this.applyListeners(b, e), this.applyListeners(g);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.applyListeners(b);
        }
      }, {
        key: "applyListeners",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.props,
              n = t.target;

          if (n) {
            var o = n;
            "string" == typeof n && (o = window[n]), x(t, e.bind(null, o));
          }
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.children || null;
        }
      }]), t;
    }(f.PureComponent);

    w.propTypes = {}, t.withOptions = function (e, t) {
      return {
        handler: e,
        options: y(t)
      };
    }, t["default"] = w;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function n(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    e.exports = function (e, t, o) {
      return t && n(e.prototype, t), o && n(e, o), e;
    };
  }, function (e, t, n) {
    var o = n(18),
        r = n(49);

    e.exports = function (e, t) {
      return !t || "object" !== o(t) && "function" != typeof t ? r(e) : t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t) {
    function n(t) {
      return e.exports = n = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, n(t);
    }

    e.exports = n;
  }, function (e, t, n) {
    var o = n(52);

    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && o(e, t);
    };
  }, function (e, t) {
    function n(t, o) {
      return e.exports = n = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, n(t, o);
    }

    e.exports = n;
  }, function (e, t, n) {
    var o = n(54);

    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          i = o(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
      }

      return i;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var n,
          o,
          r = {},
          i = Object.keys(e);

      for (o = 0; o < i.length; o++) {
        n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
      }

      return r;
    };
  }, function (e, t) {
    function n() {
      return e.exports = n = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      }, n.apply(this, arguments);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    var o = n(57),
        r = n(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e) {
      var t = function (t) {
        function n(e, t) {
          var o;
          return (0, u["default"])(this, n), (o = (0, l["default"])(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e, t))).state = {}, o.timer = null, o.handleChangeIndex = function (e, t) {
            var n = o.props,
                r = n.slideCount,
                i = n.onChangeIndex,
                a = e - t,
                u = o.state.index + a;
            r && (u = (0, f.mod)(u, r)), void 0 === o.props.index && o.setIndex(u, e, a), i && i(u, o.state.index);
          }, o.handleTransitionEnd = function () {
            o.timer = setTimeout(function () {
              o.setWindow();
            }, 0), o.props.onTransitionEnd && o.props.onTransitionEnd();
          }, o.state.index = o.props.index || 0, o;
        }

        return (0, c["default"])(n, t), (0, s["default"])(n, [{
          key: "componentWillMount",
          value: function value() {
            this.setWindow(this.state.index);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            var t = e.index;

            if ("number" == typeof t && t !== this.props.index) {
              var n = t - this.props.index;
              this.setIndex(t, this.state.indexContainer + n, n);
            }
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            clearInterval(this.timer);
          }
        }, {
          key: "setIndex",
          value: function value(e, t, n) {
            var o = {
              index: e,
              indexContainer: t,
              indexStart: this.state.indexStart,
              indexStop: this.state.indexStop
            };
            n > 0 && (!this.props.slideCount || o.indexStop < this.props.slideCount - 1) && (o.indexStop += 1), e > o.indexStop && (o.indexStop = e);
            var r = o.indexStart - e;
            r > 0 && (o.indexContainer += r, o.indexStart -= r), this.setState(o);
          }
        }, {
          key: "setWindow",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.index,
                t = this.props.slideCount,
                n = this.props.overscanSlideBefore,
                o = this.props.overscanSlideAfter;
            t && (n > e && (n = e), o + e > t - 1 && (o = t - e - 1)), this.setState({
              indexContainer: n,
              indexStart: e - n,
              indexStop: e + o
            });
          }
        }, {
          key: "render",
          value: function value() {
            for (var t = this.props, n = (t.children, t.index, t.onChangeIndex, t.onTransitionEnd, t.overscanSlideAfter, t.overscanSlideBefore, t.slideCount, t.slideRenderer), o = (0, a["default"])(t, ["children", "index", "onChangeIndex", "onTransitionEnd", "overscanSlideAfter", "overscanSlideBefore", "slideCount", "slideRenderer"]), r = this.state, u = r.indexContainer, s = r.indexStart, l = r.indexStop, c = [], f = s; f <= l; f += 1) {
              c.push(n({
                index: f,
                key: f
              }));
            }

            return d["default"].createElement(e, (0, i["default"])({
              index: u,
              onChangeIndex: this.handleChangeIndex,
              onTransitionEnd: this.handleTransitionEnd
            }, o), c);
          }
        }]), n;
      }(d.PureComponent);

      return t.defaultProps = {
        overscanSlideAfter: 2,
        overscanSlideBefore: 3
      }, t.propTypes = {}, t;
    };
    var i = r(n(10)),
        a = r(n(11)),
        u = r(n(12)),
        s = r(n(13)),
        l = r(n(14)),
        c = r(n(15)),
        d = o(n(0)),
        f = (r(n(2)), n(3));
  }, function (e, t) {
    e.exports = function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var n in e) {
        if (Object.prototype.hasOwnProperty.call(e, n)) {
          var o = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(e, n) : {};
          o.get || o.set ? Object.defineProperty(t, n, o) : t[n] = e[n];
        }
      }
      return t["default"] = e, t;
    };
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.on = function (e, t, n, o) {
      o = o || !1, e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent && e.attachEvent("on" + t, function (t) {
        n.call(e, t || window.event);
      });
    }, t.off = function (e, t, n, o) {
      o = o || !1, e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent && e.detachEvent("on" + t, n);
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e) {
      if (!(e instanceof HTMLElement)) return document.documentElement;

      for (var t = "absolute" === e.style.position, n = /(scroll|auto)/, o = e; o;) {
        if (!o.parentNode) return e.ownerDocument || document.documentElement;
        var r = window.getComputedStyle(o),
            i = r.position,
            a = r.overflow,
            u = r["overflow-x"],
            s = r["overflow-y"];
        if ("static" === i && t) o = o.parentNode;else {
          if (n.test(a) && n.test(u) && n.test(s)) return o;
          o = o.parentNode;
        }
      }

      return e.ownerDocument || e.documentElement || document.documentElement;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e, t, n) {
      var o = void 0,
          r = void 0,
          i = void 0,
          a = void 0,
          u = void 0,
          s = function s() {
        var l = +new Date() - a;
        l < t && l >= 0 ? o = setTimeout(s, t - l) : (o = null, n || (u = e.apply(i, r), o || (i = null, r = null)));
      };

      return function () {
        i = this, r = arguments, a = +new Date();
        var l = n && !o;
        return o || (o = setTimeout(s, t)), l && (u = e.apply(i, r), i = null, r = null), u;
      };
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t["default"] = function (e, t, n) {
      var o, r;
      return t || (t = 250), function () {
        var i = n || this,
            a = +new Date(),
            u = arguments;
        o && a < o + t ? (clearTimeout(r), r = setTimeout(function () {
          o = a, e.apply(i, u);
        }, t)) : (o = a, e.apply(i, u));
      };
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(0),
        r = n.n(o),
        i = n(1),
        a = n.n(i),
        u = n(2),
        s = n.n(u),
        l = n(5),
        c = n.n(l),
        d = n(19);

    function f(e, t) {
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
    }

    function p(e, t) {
      if (null == e) return {};
      var n,
          o,
          r = {},
          i = Object.keys(e);

      for (o = 0; o < i.length; o++) {
        n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
      }

      return r;
    }

    function h() {
      return (h = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var o in n) {
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    var v = function v(e) {
      return "function" == typeof e;
    },
        y = function y(e) {
      var t = e.children,
          n = e.render;

      for (var o = v(t) ? t : n, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
        i[a - 1] = arguments[a];
      }

      return o ? o.apply(void 0, i) : null;
    },
        m = function m() {},
        g = function (e) {
      function t() {
        for (var t, n = arguments.length, o = new Array(n), r = 0; r < n; r++) {
          o[r] = arguments[r];
        }

        return (t = e.call.apply(e, [this].concat(o)) || this).state = {
          value: t.props.initial
        }, t._set = function (e, n) {
          void 0 === n && (n = m);
          var o = t.props.onChange,
              r = void 0 === o ? m : o;
          t.setState("function" == typeof e ? function (t) {
            return {
              value: e(t.value)
            };
          } : {
            value: e
          }, function () {
            r(t.state.value), n();
          });
        }, t._reset = function (e) {
          void 0 === e && (e = m), t._set(t.props.initial, e);
        }, t;
      }

      return f(t, e), t.prototype.render = function () {
        return y(this.props, {
          value: this.state.value,
          set: this._set,
          reset: this._reset
        });
      }, t;
    }(o.Component),
        b = (o.Component, function (e) {
      var t = e.initial,
          n = void 0 === t ? {} : t,
          r = e.onChange,
          i = p(e, ["initial", "onChange"]);
      return Object(o.createElement)(g, {
        initial: n,
        onChange: r
      }, function (e) {
        var t = e.value,
            n = e.set,
            o = e.reset;
        return y(i, {
          state: t,
          setState: function setState(e, t) {
            return n(function (t) {
              return h({}, t, "function" == typeof e ? e(t) : e);
            }, t);
          },
          resetState: o
        });
      });
    }),
        x = n(20),
        w = n.n(x);

    function S(e) {
      return (S = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function O(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function C(e) {
      return (C = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function E(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function _(e, t) {
      return (_ = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function j(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var T = function (e) {
      function t(e) {
        var n, o, r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o = this, r = C(t).call(this, e), n = !r || "object" !== S(r) && "function" != typeof r ? E(o) : r, j(E(n), "image", void 0), j(E(n), "timer", void 0), j(E(n), "loadImageFromCache", function (e, t) {
          e && (n.loadImage(e), n.timer = setTimeout(function () {
            n.state.image !== e && n.setState({
              image: t,
              loading: !0
            });
          }, 100));
        }), j(E(n), "loadImage", function (e) {
          n.image && (n.image.onload = null, n.image.onerror = null);
          var t = new Image();
          n.image = t, t.onload = n.onLoad, t.onerror = n.onError, t.src = e;
        }), j(E(n), "onLoad", function () {
          n.setState({
            image: n.image.src,
            loading: !1
          });
        }), j(E(n), "onError", function (e) {
          var t = n.props.onError;
          t && t(e);
        }), n.state = {
          image: "",
          loading: !0
        }, n;
      }

      var n, r, i;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && _(e, t);
      }(t, e), n = t, (r = [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
              t = e.src,
              n = e.placeholder;
          this.loadImageFromCache(t, n);
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          var t = this.props,
              n = t.src,
              o = t.placeholder;
          n !== e.src && this.loadImageFromCache(n, o);
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.image && (this.image.onload = null, this.image.onerror = null), clearTimeout(this.timer);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.state,
              t = e.image,
              n = e.loading,
              r = this.props.children;
          return o.Children.only(r(t, n));
        }
      }]) && O(n.prototype, r), i && O(n, i), t;
    }(o.Component),
        I = a.a.div.withConfig({
      displayName: "Overlay",
      componentId: "sc-1xdfgjc-0"
    })(["position:absolute;top:0;left:0;width:100%;height:100%;border-radius:4px;background-color:rgba(0,0,0,.03);"]),
        M = Object(i.keyframes)(["0%,80%,100%{box-shadow:0 2.5em 0 -1.3em;}40%{box-shadow:0 2.5em 0 0;}"]),
        k = a.a.div.withConfig({
      displayName: "Bubble",
      componentId: "sc-1b2u59h-0"
    })(["animation:", ";animation-delay:", ";animation-fill-mode:both;border-radius:50%;color:", ";opacity:", ";font-size:", ";height:2.5em;margin:0px auto 30px auto;position:relative;text-indent:-9999em;transform:translateZ(0);width:2.5em;&:before{animation:", ";animation-delay:", ";animation-fill-mode:both;border-radius:50%;content:'';height:2.5em;left:-3.5em;position:absolute;top:0;width:2.5em;}&:after{animation:", ";animation-fill-mode:both;border-radius:50%;content:'';height:2.5em;left:3.5em;position:absolute;top:0;width:2.5em;}"], function (e) {
      return "".concat(M, " ").concat(e.duration, "s infinite ease-in-out;");
    }, function (e) {
      return "".concat(-.16 * e.duration, "s");
    }, function (e) {
      return e.color;
    }, function (e) {
      return e.opacity;
    }, function (e) {
      return "".concat(e.size, "px");
    }, function (e) {
      return "".concat(M, " ").concat(e.duration, "s infinite ease-in-out;");
    }, function (e) {
      return "".concat(-.32 * e.duration, "s");
    }, function (e) {
      return "".concat(M, " ").concat(e.duration, "s infinite ease-in-out;");
    }),
        P = function P(e) {
      return r.a.createElement(k, e);
    };

    P.defaultProps = {
      loading: !0,
      color: "#9e9e9e",
      duration: 1.2,
      size: 6,
      opacity: .5
    };

    var L = P,
        N = a.a.button.withConfig({
      displayName: "PaginationDot__Button",
      componentId: "sc-1motyo6-0"
    })(["height:18px;width:18px;cursor:pointer;border:0;background:none;padding:0;:focus{outline:0;}display:flex;align-items:center;justify-content:center;"]),
        D = a.a.div.withConfig({
      displayName: "PaginationDot__StyleDot",
      componentId: "sc-1motyo6-1"
    })(["background-color:white;opacity:", ";height:", ";width:", ";border-radius:", ";"], function (e) {
      return e.active ? "1" : "0.6";
    }, function (e) {
      var t = e.active,
          n = e.moreState;
      return t ? "8px" : n ? "4px" : "6px";
    }, function (e) {
      var t = e.active,
          n = e.moreState;
      return t ? "8px" : n ? "4px" : "6px";
    }, function (e) {
      return e.active ? "4px" : "3px";
    }),
        X = function X(e) {
      var t = e.active,
          n = e.index,
          o = e.moreState,
          i = e.onClick;
      return r.a.createElement(N, {
        onClick: function onClick(e) {
          return i(e, n);
        }
      }, r.a.createElement(D, {
        active: t,
        moreState: o
      }));
    },
        A = {
      slideContainer: {
        width: "18px",
        height: "18px"
      }
    },
        W = a.a.div.withConfig({
      displayName: "Pagination__PaginationWrapper",
      componentId: "v8tudh-0"
    })(["position:absolute;display:flex;justify-content:center;bottom:8px;right:8px;left:8px;"]),
        H = function H(e) {
      for (var t = e.index, n = e.slideCount, o = e.onChangeIndex, i = [], a = 0; a < n; a += 1) {
        var u = !1;
        6 === a && t < 4 && n > 7 ? u = !0 : a === n - 7 && t > n - 5 && n > 7 ? u = !0 : (a > 4 || a < n - 5) && t > 3 && t < n - 4 && (t >= a + 3 || t <= a - 3) && (u = !0), i.push(r.a.createElement(X, {
          key: a,
          index: a,
          active: a === t,
          moreState: u,
          onClick: function onClick(e, t) {
            return o(t);
          }
        }));
      }

      var s = ((n > 7 ? 7 : n) - 1) / 2,
          l = t;
      return t < 3 ? l = 3 : t > n - 4 && (l = n - 4), n < 8 && (l = 0, s = (7 - n) / 2), r.a.createElement(W, null, r.a.createElement(c.a, {
        index: l,
        style: {
          width: "126px",
          padding: "0px ".concat(18 * s, "px")
        },
        slideStyle: A.slideContainer,
        disabled: !0
      }, i));
    },
        R = Object(i.css)(["right:0;background:rgb(255,255,255);background:linear-gradient( 90deg,rgba(255,255,255,0) 0%,rgba(0,0,0,0.5) 100% );"]),
        U = Object(i.css)(["left:0;background:rgb(2,0,36);background:linear-gradient( 90deg,rgba(0,0,0,0.5) 0%,rgba(255,255,255,0) 100% );"]),
        z = a.a.div.withConfig({
      displayName: "ArrowNavigation__NavigationButton",
      componentId: "sc-1fk7ttj-0"
    })(["justify-content:center;align-items:center;display:flex;position:absolute;bottom:0;top:0;width:25%;max-width:100px;cursor:pointer;", ";"], function (e) {
      return e.left ? U : R;
    }),
        B = function B(e) {
      var t = e.onChangeIndex,
          n = e.index,
          o = e.slideCount,
          i = e.onMouseLeave,
          a = e.onMouseEnter,
          u = e.onTouchStart,
          s = e.onTouchEnd;
      return [r.a.createElement(z, {
        key: "next-nav",
        onClick: function onClick() {
          return t(o - 1 > n ? n + 1 : 0);
        },
        onMouseLeave: i,
        onMouseEnter: a,
        onTouchStart: u,
        onTouchEnd: s
      }, r.a.createElement("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        role: "img",
        fill: "currentColor",
        color: "white"
      }, r.a.createElement("path", {
        d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
      }))), r.a.createElement(z, {
        key: "before-nav",
        width: [.25],
        onClick: function onClick() {
          return t(n > 0 ? n - 1 : o - 1);
        },
        onMouseLeave: i,
        onMouseEnter: a,
        onTouchStart: u,
        onTouchEnd: s,
        left: !0
      }, r.a.createElement("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        role: "img",
        fill: "currentColor",
        color: "white"
      }, r.a.createElement("path", {
        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      })))];
    };

    function Y(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var F = Object(d.virtualize)(c.a),
        q = a.a.div.withConfig({
      displayName: "AirbnbCarousel__BackgroundImage",
      componentId: "sc-15wthbx-0"
    })(["width:100%;padding-bottom:", "%;background-size:contain;background-position:center;background-repeat:no-repeat;background-color:lightgray;", ";", ";"], function (e) {
      return 100 / e.ratio;
    }, function (e) {
      return e.src ? Object(i.css)(["background-image:url(", ");"], e.src) : Object(i.css)([""]);
    }, function (e) {
      var t = e.loading,
          n = e.src;
      return t && n ? Object(i.css)(["filter:blur(8px);"]) : Object(i.css)(["filter:blur(0px);transition:300ms filter ease;"]);
    }),
        V = a.a.div.withConfig({
      displayName: "AirbnbCarousel__Flex",
      componentId: "sc-15wthbx-1"
    })(["display:flex;justify-content:center;align-items:center;position:relative;"]),
        K = a.a.div.withConfig({
      displayName: "AirbnbCarousel__Box",
      componentId: "sc-15wthbx-2"
    })(["width:100%;position:absolute;z-index:1;"]),
        Z = a.a.div.withConfig({
      displayName: "AirbnbCarousel__Wrapper",
      componentId: "sc-15wthbx-3"
    })(["position:relative;*{box-sizing:border-box;}"]),
        G = function G(e) {
      var t = e.placeholderUrl,
          n = e.imageUrls,
          o = e.initialIndex,
          i = e.ratio,
          a = e.overlay,
          u = n.length || 0,
          s = r.a.createElement(q, {
        src: t || "",
        ratio: i
      });
      return r.a.createElement(w.a, {
        once: !0,
        placeholder: s,
        offset: 960
      }, r.a.createElement(b, {
        initial: {
          index: o,
          loadedIndexes: [0],
          hover: !1
        }
      }, function (e) {
        var o = e.state,
            s = e.setState;
        return r.a.createElement(Z, null, r.a.createElement(F, {
          index: o.index,
          overscanSlideAfter: 6,
          overscanSlideBefore: 2,
          onChangeIndex: function onChangeIndex(e) {
            return s({
              index: e,
              loadedIndexes: [e].concat(Y(o.loadedIndexes))
            });
          },
          onMouseEnter: function onMouseEnter() {
            return s({
              hover: !0
            });
          },
          onMouseLeave: function onMouseLeave() {
            return s({
              hover: !1
            });
          },
          onTouchStart: function onTouchStart() {
            return o.hover ? s({
              hover: !1
            }) : void 0;
          },
          onTouchEnd: function onTouchEnd() {
            return o.hover ? s({
              hover: !1
            }) : void 0;
          },
          slideCount: u,
          slideRenderer: function slideRenderer(e) {
            var o = e.index,
                u = e.key,
                s = n[o];
            return r.a.createElement(T, {
              key: u,
              src: s,
              placeholder: t || ""
            }, function (e, t) {
              return r.a.createElement(V, null, t && e && r.a.createElement(K, {
                position: "absolute",
                zIndex: 1
              }, r.a.createElement(L, {
                loading: t,
                color: "white"
              })), r.a.createElement(q, {
                loading: t,
                key: u,
                src: e,
                ratio: i
              }), a && r.a.createElement(I, null));
            });
          }
        }), n.length > 1 && o.hover && r.a.createElement(B, {
          slideCount: u,
          index: o.index || 0,
          onMouseEnter: function onMouseEnter() {
            return s({
              hover: !0
            });
          },
          onMouseLeave: function onMouseLeave() {
            return s({
              hover: !1
            });
          },
          onTouchStart: function onTouchStart() {
            return o.hover ? s({
              hover: !1
            }) : void 0;
          },
          onTouchEnd: function onTouchEnd() {
            return o.hover ? s({
              hover: !1
            }) : void 0;
          },
          onChangeIndex: function onChangeIndex(e) {
            s({
              index: e,
              loadedIndexes: [e].concat(Y(o.loadedIndexes))
            });
          }
        }), n.length > 1 && r.a.createElement(H, {
          slideCount: u,
          index: o.index || 0,
          onChangeIndex: function onChangeIndex(e) {
            return s({
              index: e,
              loadedIndexes: [e].concat(Y(o.loadedIndexes))
            });
          }
        }));
      }));
    };

    G.propTypes = {
      placeholderUrl: s.a.string,
      imageUrls: s.a.arrayOf(s.a.string).isRequired,
      initialIndex: s.a.number,
      ratio: s.a.number,
      overlay: s.a.bool
    }, G.defaultProps = {
      placeholderUrl: "",
      initialIndex: 0,
      ratio: 4 / 3,
      overlay: !1
    };
    t["default"] = G;
  }]);
});